<form
        (submit)="submitForm()"
        [formGroup]="loginForm"
        class="auth-form"
>
    <i class="auth-form__icon">
        <lta-logo [type]="'login'"></lta-logo>
    </i>
    <div class="auth-form__input-group">
        <lta-input
                *ngIf="isElectron && !preconfiguredServer"
                formControlName="host"
                label="{{ 'lta-login.host' | translate }}"
                placeholder="192.168.0.0"
                type="text"
        ></lta-input>
        <lta-select
                [iconOptions]="{asCanvas: false, width: 20, height: 20}"
                [selectOptions]="entryWindowTypes"
                formControlName="type_entry_window"
                icon="hmi"
                label="{{ 'lta-login.userManagementSystem' | translate }}"
        ></lta-select>
        <lta-input
                formControlName="login"
                icon="user"
                label="{{ 'lta-login.login' | translate }}"
                placeholder="{{ 'lta-login.userName' | translate }}"
                type="text"
        ></lta-input>
        <lta-input
                formControlName="password"
                icon="lock"
                label="{{ 'lta-login.password' | translate }}"
                placeholder="{{ 'lta-login.password' | translate }}"
                type="password"
        ></lta-input>
        <span
                *ngIf="error$ | async as error"
                class="error"
        >{{ error | translate }}</span>
    </div>
    <lta-btn
            [disabled]="isLoading || !loginForm.valid || isLoggedIn"
            [isLoading]="isLoading"
            class="auth-form__btn"
            size="lg"
            theme="primary"
    >
        <span>{{ 'lta-login.logIn' | translate }}
            <lta-svg-icon
                    *ngIf="!isLoading"
                    icon="arrow-right"
                    size="20"
            ></lta-svg-icon>
        </span>
    </lta-btn>
    <!--    <a-->
    <!--            class="auth-form__restore"-->
    <!--            routerLink="./restore"-->
    <!--    >{{'lta-login.restoreAccess' | translate}}</a>-->
</form>
